export const formatArea = (value: number | undefined | null) => {
  if (!value) {
    return;
  }

  return `${value} м²`;
};
